import { Link } from "react-router-dom";
import { useAuthInfo } from "@/hooks/use-auth-info";
import { Button } from "./ui/button";

export function Sidenav() {
	const { hasPermission } = useAuthInfo();

	return (
		<nav className="flex flex-col gap-y-2 justify-start items-start border-b md:border-b-0 md:border-r">
			{hasPermission("members") && (
				<Button variant="link" className="p-0">
					<Link to="/dashboard/members" viewTransition>
						- Members
					</Link>
				</Button>
			)}
			{hasPermission("groups") && (
				<Button variant="link" className="p-0">
					<Link to="/dashboard/groups" viewTransition>
						- Groups
					</Link>
				</Button>
			)}
			{hasPermission("invites") && (
				<Button variant="link" className="p-0">
					<Link to="/dashboard/invites" viewTransition>
						- Invites
					</Link>
				</Button>
			)}
			{hasPermission("push_notifications") && (
				<>
					<Button variant="link" className="p-0">
						<Link to="/dashboard/devices" viewTransition>
							- Devices
						</Link>
					</Button>
					<Button variant="link" className="p-0">
						<Link to="/dashboard/push-notifications" viewTransition>
							- Push Notifications
						</Link>
					</Button>
				</>
			)}
			{hasPermission("reimbursements-reviewer") && (
				<Button variant="link" className="p-0">
					<Link to="/dashboard/reimbursements" viewTransition>
						- Reimbursements
					</Link>
				</Button>
			)}
		</nav>
	);
}
